// ConfirmDeleteDialog.js
import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Button,
} from "@mui/material";

const DeleteConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  typeDelete,
  setTypeDelete,
}) => {
  const handleConfirm = () => {
    if (typeDelete.toLowerCase() === "delete") {
      onConfirm();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth="sm">
      <DialogTitle>Delete Record</DialogTitle>
      <DialogContent>
        <DialogContentText mb={1}>
          To confirm, type "delete" in the box below.
        </DialogContentText>
        <TextField
          size="small"
          fullWidth
          value={typeDelete}
          onChange={(e) => setTypeDelete(e.target.value)}
          // placeholder="Type 'delete' to confirm"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          disabled={typeDelete.toLowerCase() !== "delete"}
          color="error"
          variant="contained"
          sx={{
            margin: "10px 0",
            // backgroundColor:
            //   typeDelete.toLowerCase() === "delete" ? "#b41660" : "#ccc",
            // color: typeDelete.toLowerCase() === "delete" ? "#fff" : "#888",
            cursor:
              typeDelete.toLowerCase() === "delete" ? "pointer" : "not-allowed",
          }}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationModal;
